import CheckIcon from '@assets/icons/check.svg?react'
import clsx from 'clsx'

import s from './Checkbox.module.scss'
import type { CheckboxProps } from './Checkbox.props'

export function Checkbox({ label, icon, className, ...props }: CheckboxProps) {
  return (
    <label>
      <input
        className={s.input}
        {...props}
        type="checkbox"
      />
      <span className={clsx(s.wrapper, className, { [s.withIcon]: !!icon })}>
        <span className={s.iconWrapper}>
          {!!icon && (
            <img
              src={icon}
              alt="Icon"
              width={44}
              height={44}
              className={s.icon}
            />
          )}
          <span className={s.control}>
            <CheckIcon className={s.checkIcon} />
          </span>
        </span>
        <span className={s.label}>{label}</span>
      </span>
    </label>
  )
}
